module.exports = __webpack_public_path__ + "static/img/partner_4.8b026d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_4.png
// module id = QK4Y
// module chunks = 0